export default __webpack_public_path__ + "static/media/Single-Select.e7b64788.gif";